module.exports = __webpack_public_path__ + "img/cat6.be96f07.png";